import * as React from 'react';
import { Map } from '@vis.gl/react-google-maps';

// Utils
// Constants
import { GOOGLE_MAPS_MAP_IDS } from '@toolkit/const/app';
// Actions, Models & Interfaces
import { HotelModel, CoordinatesModel } from '@src/shared/src/models';
// Components
import HotelDestMarker from './HotelDestMarker';
import HotelMapMarker from './HotelMapMarker';
// Styles
import '../styles/HotelMap.scss';

type Props = {
  hotel: HotelModel;
  destCoord: CoordinatesModel;
};

const HotelMapDetails: React.FC<Props> = ({ hotel, destCoord }) => {
  return (
    <div className="tcp-hotel-details-map">
      <div className="tcp-hotel-details-map-element">
        <Map
          defaultZoom={12}
          clickableIcons={false}
          defaultCenter={{ lat: hotel.latitude, lng: hotel.longitude }}
          minZoom={8}
          maxZoom={17}
          fullscreenControl={false}
          mapTypeControl={false}
          streetViewControl={false}
          reuseMaps={true}
          mapId={GOOGLE_MAPS_MAP_IDS.HOTELS_MAP_ID}>
          <HotelMapMarker hotel={hotel} />
          <HotelDestMarker position={destCoord} />
        </Map>
      </div>
    </div>
  );
};

export default HotelMapDetails;
